import router from './router'
// import { setShare } from './share'
import { getUrlKey } from '@/utils/index' // 获取url参数
// import { getLogin, setLogin } from '@/utils/auth' // 获取url参数
// import { visit } from '@/api/statistics'
// import { getCode, getToken } from '@/api/interview'

router.beforeEach((to, from, next) => {
  // var activityId = getUrlKey('activityId') // 活动ID
  // var channel = getUrlKey('channel') // 投放平台
  // var income = getUrlKey('income') // 渠道ID
  window.location.href = 'https://front.crm.yes-go.cn/frontend-h5/dist/interview.html?' +
    'activityId=' + getUrlKey('activityId') +
    (getUrlKey('income') ? '&income=' + getUrlKey('income') : '') +
    (getUrlKey('discountKey') ? '&discountKey=' + getUrlKey('discountKey') : '') +
    (getUrlKey('paymentCode') ? '&paymentCode=' + getUrlKey('paymentCode') : '')
  // // 百度代码统计
  // var _hmt = _hmt || [];
  // (function() {
  //   var hm = document.createElement('script')
  //   hm.src = 'https://hm.baidu.com/hm.js?48129afbb09716083acae0ce8b3fedf5'
  //   var s = document.getElementsByTagName('script')[0]
  //   s.parentNode.insertBefore(hm, s)
  // })()
  // // 判断是否微信环境
  // if (checkWx()) {
  //   var urlCode = getUrlKey('code')
  //   var wxKey = getUrlKey('WxKey')
  //   const url = window.location.host + window.location.pathname + '?WxKey=' + wxKey + '&activityId=' + activityId + '&income=' + income
  //   if (getLogin()) {
  //     next()
  //     setShare({ activityId: activityId, wxKey: wxKey, income: income })
  //   } else {
  //     if (urlCode) {
  //       // 071Wzu000j8FlL1XkH100jfE0O0Wzu0s
  //       console.log('code')
  //       getToken({ WxKey: wxKey, code: urlCode }).then(res => {
  //         if (res.data.code === 200) {
  //           setLogin(res.data.data.openid)
  //           window.location.href = window.location.protocol + '//' + url
  //         } else if (res.data.code === 3021) { // 重新授权
  //           getCode({ WxKey: wxKey, url: url }).then(res => {
  //             window.location.href = res.data.data.url
  //           })
  //         }
  //       })
  //     } else {
  //       getCode({ WxKey: wxKey, url: url }).then(res => {
  //         window.location.href = res.data.data.url
  //       })
  //       console.log('跳转授权')
  //     }
  //   }
  // } else {
  //   if (channel === 'zhihu') {
  //     console.log(channel);
  //     (function(root) {
  //       window.zhad = []
  //       var tag = document.createElement('script'); tag.type = 'text/javascript'; tag.async = true
  //       tag.src = '//unpkg.zhimg.com/@efe/zhad-tracker@1.4.1'
  //       tag.onerror = function() {
  //         var img = new Image()
  //         img.src = '//sugar.zhihu.com/log_fe?js_url=' + window.encodeURIComponent(tag.src) + '&t=' + (+new Date())
  //       }
  //       var s = document.getElementsByTagName('script')[0]
  //       s.parentNode.insertBefore(tag, s)
  //     })()
  //   }
  //   if (channel === 'bilibili') {
  //     console.log(channel)
  //     const _hmt = _hmt || [];
  //     (function() {
  //       var hm = document.createElement('script')
  //       hm.src = 'https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js'
  //       var s = document.getElementsByTagName('head')[0]
  //       s.parentNode.insertBefore(hm, s)
  //     })()
  //   }
  //   visit('进入面试预约')
  //   next()
  // }
})

